import React, { useEffect, useMemo, useState } from "react";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import { getStoryHeadline } from "../../utils/story";
import { shortenUrl } from "../../../../api/utils";

import "./recipe.m.css";

export default function ShareMenuItems({ story }) {
  const [shortStoryUrl, setShortStoryUrl] = useState(story?.url);
  const headline = getStoryHeadline(story);

  useEffect(() => {
    const fetchShortUrl = async () => {
      try {
        const data = await shortenUrl(story?.url);
        setShortStoryUrl(data?.shortUrl);
      } catch (err) {
        console.error("Failed to shorten URL: ", err);
      }
    };

    if (story?.url) {
      fetchShortUrl();
    }
  }, [story?.url]);

  const shareIconSet = useMemo(
    () => [
      { id: "share-facebook", label: "Facebook", url: `https://www.facebook.com/sharer.php?u=${shortStoryUrl}` },
      {
        id: "share-x",
        label: "X",
        url: `https://twitter.com/intent/tweet?url=${shortStoryUrl}&text=${encodeURIComponent(headline)}`,
      },
      { id: "share-whatsapp", label: "Whatsapp", url: `https://api.whatsapp.com/send?text=${shortStoryUrl}` },
      { id: "share-mail", label: "E-mail", url: `mailto:?subject=${headline}&body=${shortStoryUrl}` },
      {
        id: "share-linkedin",
        label: "Linkedin",
        url: `https://www.linkedin.com/shareArticle?url=${shortStoryUrl}&title=${encodeURIComponent(headline)}`,
      },
    ],
    [shortStoryUrl, headline]
  );
  return (
    <>
      {shareIconSet.map((item, index) => {
        return (
          <Link key={index} href={item?.url} target="_blank">
            <SvgIconHandler type={item.id} height="32px" width="32px" viewBox="0 0 32 32" />
            <span>{item?.label}</span>
          </Link>
        );
      })}
    </>
  );
}
